import(/* webpackMode: "eager" */ "/workspace/app/product/error.jsx")